module.exports = __webpack_public_path__ + "static/media/business_page.30fc48d5.png";